// extracted by mini-css-extract-plugin
export var formContainer = "_k3-0";
export var message = "_k3-1";